import React from "react";

import { Header } from "semantic-ui-react";

import { IntegrationApps, IntegrationSettings } from "./components";

function Integrations() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "2em",
        }}
      >
        <Header as="h1">Connected Apps</Header>

        <IntegrationApps showConnectedApps />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "2em",
        }}
      >
        <Header as="h1">Available Apps</Header>

        <IntegrationApps />
      </div>

      <IntegrationSettings />
    </div>
  );
}

export default Integrations;
